import { render, staticRenderFns } from "./supRegDetail.vue?vue&type=template&id=18909d56&scoped=true&"
import script from "./supRegDetail.vue?vue&type=script&lang=js&"
export * from "./supRegDetail.vue?vue&type=script&lang=js&"
import style0 from "./supRegDetail.vue?vue&type=style&index=0&id=18909d56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18909d56",
  null
  
)

export default component.exports